import Repository from "./CeraBaseRepositoryFactory";

const get = "get";
const create = "create";
const update = "update";
const eSignRequest = "eSignRequest";
const eSignWidget = "eSignWidget";
const headingPages = "getHeadingsPages";

export default {
  getAgreement(payload) {
    return Repository.post(transformRoute(get), payload);
  },
  createAgreement(payload) {
    return Repository.post(transformRoute(create), payload);
  },
  updateAgreement(payload) {
    return Repository.post(transformRoute(update), payload);
  },
  geteSignRequest(payload) {
    return Repository.post(transformRoute(eSignRequest), payload, {
      headers: {
        Accept: "application/json",
        "community-name": "dash",
      },
    });
  },
  geteSignWidget(payload) {
    return Repository.post(transformRoute(eSignWidget), payload);
  },
  getHeadingsPages(payload) {
    return Repository.post(transformRoute2(headingPages), payload);
  },
};

const transformRoute = (route) => {
  return `/masters/agreement/${route}`;
};

const transformRoute2 = (route) => {
  return `/masters/page/${route}`;
};
